import { ReactElement } from "react";
import { PaymentsModalType } from "entities/shared/subscriptionModel";
import { subscriptionStore } from "entities/Subscription";
import { useAppSelector } from "shared/lib/redux";
import { useTranslation } from "shared/localization/localization";
import { Link } from "shared/ui/Button";
import { PRICING_PAGE_URL } from "shared/utils/url.utils";
import styles from "./PaymentsModalTopDescription.module.scss";

export const PaymentsModalTopDescription: RFC = () => {
  const { t } = useTranslation();

  const activePaymentModal = useAppSelector(subscriptionStore.selectors.activePaymentModal);
  const subscription = useAppSelector(subscriptionStore.selectors.subscription);

  const paymentsModalTopDescriptionMap: Record<PaymentsModalType, ReactElement | null> = {
    [PaymentsModalType.PAY]: (
      <p className={styles.payDescription}>
        {t(
          "To continue enjoying the full benefits of our tracking features and keep your important processes running smoothly, please explore our pricing plans and choose the one that best suits your needs."
        )}
      </p>
    ),
    [PaymentsModalType.FREE]: (
      <p className={styles.freeDescription}>
        <div className={styles.freeDescriptionText}>
          {t("Your next")} {subscription?.uniqueShipments?.total}{" "}
          {t("credits will be available next month. Please note that the free plan allows for")} {subscription?.total}{" "}
          {t("credits per day, with a maximum of")} {subscription?.uniqueShipments?.total} {t("per month")}.{" "}
        </div>
        {t("Upgrade your account with one of our ")}{" "}
        <Link target="_blank" href={PRICING_PAGE_URL} className={styles.descriptionLink}>
          {t("tariff plans")}
        </Link>{" "}
        {t(" to remove these restrictions and get the most out of our features.")}{" "}
      </p>
    ),
  };

  if (!activePaymentModal) return null;

  return paymentsModalTopDescriptionMap[activePaymentModal];
};
